(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["clearance-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-clearance-menu]').forEach(function(menu){var fine=window.matchMedia('(hover:hover) and (pointer:fine)'),timer;menu.querySelector('summary').addEventListener('click',function(event){event.preventDefault();clearTimeout(timer);menu.open=true;});menu.addEventListener('mouseenter',function(){if(fine.matches){clearTimeout(timer);menu.open=true;}});menu.addEventListener('mouseleave',function(){if(fine.matches){timer=setTimeout(function(){if(!menu.contains(document.activeElement)){menu.open=false;}},180);}});menu.addEventListener('keydown',function(event){if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});document.addEventListener('click',function(event){if(!menu.contains(event.target)){menu.open=false;}});});
  } catch(e) { console.error(e); }
})();

})();
